prismanoteApp.controller('previewCampaignModalController', ['$scope', '$uibModalInstance', 'campaign', 'campaignFact',
  function ($scope, $uibModalInstance, campaign, campaignFact) {
    $scope.campaign = campaign
    campaignFact.campObj = campaign
    $scope.confirm = function () {
      $uibModalInstance.close(true)
    }
  }])
